import React, { Fragment, useState, useEffect } from 'react'
import { Link as RouterLink } from "react-router-dom"
import { createForm } from 'rc-form'
import { useTranslation } from 'react-i18next'
import { fromJS } from 'immutable';
import numeral from 'numeral'

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Edit from '@material-ui/icons/Edit'
import Link from '@material-ui/core/Link'

import Block from 'components/common/Block'
import UpdateInvoiceDialog from 'components/dialog/UpdateInvoiceDialog'
import AddCreditCardDialog from 'components/dialog/AddCreditCardDialog'
import FormFieldGrid from 'components/common/FormFieldGrid';

import { formatNumber, formatDate, receiptTypeEnum } from 'libraries/utils'

const InboundDetailForm = props => {
    const { t } = useTranslation();
    const { memberInfo, couponlist, orderInfo } = props 
    const { validateFields } = props.form

    // form field
    const [receiptType, setReceiptType] = useState(memberInfo.receiptType.toString() || receiptTypeEnum.THREE_LINE) // 發票種類
    const [receiptTitle, setReceiptTitle] = useState(memberInfo.receiptTitle || '') // 發票抬頭
    const [receiptTaxId, setReceiptTaxId] = useState(memberInfo.receiptTaxId || '') // 發票 統一編號
    const [ccLastFour, setCcLastFour] = useState(memberInfo.creditCardLastFour || '') // 信用卡後四碼
	const [selectedCoupon, setSelectedCoupon] = useState(fromJS({})) // 優惠券

    // error
    const [receiptErr, setReceiptErr] = useState(false)
    const [creditCardErr, setCreditCardErr] = useState(false)
    
    // dialog
    const [openInvoiceDialog, setOpenInvoiceDialog] = useState(false)
    const [openCreditCardDialog, setOpenCreditCardDialog] = useState(false)

    const process_fee = orderInfo.get('processFee') || 0 // 處理費用
    const storage_fee = orderInfo.get('storageFee') || 0 // 儲存費用
    const subTotal = numeral(process_fee).add(storage_fee) // 小計
    const total =  numeral(process_fee).add(storage_fee).subtract(selectedCoupon.get('couponAmount') || 0) // 總計
    
    const handleCreditCardDialog = () => {
        setOpenCreditCardDialog(!openCreditCardDialog)
    }
    
    const udpateCreditCard = (data) => {
        setCcLastFour(data)
        setOpenCreditCardDialog(false)
    }
    
    const handleInvoiceDialog = () => {
        setOpenInvoiceDialog(!openInvoiceDialog)
    }
    
    const updateInvoice = (data) => {
        setReceiptType(data.receiptType.toString())
        setReceiptTitle(data.receiptTitle)
        setReceiptTaxId(data.receiptTaxId)
        setOpenInvoiceDialog(false)
    }

    const handleReceiptType = (event) => {
        setReceiptType(event.target.value);
    }

    const handleCouponChange = (event) => {
        const couponId = event.target.value
        const selectedCoupon = couponlist.filter(item => item.get('storageCouponId') === couponId).get(0)
            || fromJS({})
        setSelectedCoupon(selectedCoupon)
    }

    const handleSubmit = () => {
        setReceiptErr(false)
        setCreditCardErr(false)
        let error = []
        if(receiptType === '3' && (!receiptTitle || !receiptTaxId)) {
            error.push('Receipt')
            setReceiptErr(true)
        }
        if(!ccLastFour){
            error.push('CreditCard')
            setCreditCardErr(true)
        }
        if(error.length === 0){
            const formData = {
                receiptType: parseInt(receiptType),
                receiptTitle,
                receiptTaxId,
            }
            props.onSubmit(formData)
        }
    }

	return (
		<Fragment>
            {/* 發票資訊 */}
            <Block
                title={t('receipt_info')}
                contClassname="bg-white main-block"
                error={receiptErr}
                errorMsg={'*發票資料不完整或有誤'}
            >
                <RadioGroup
                    name="receiptType"
                    value={receiptType}
                    onChange={handleReceiptType}
                    className="receipt-type"
                >
                    <FormControlLabel value={receiptTypeEnum.TWO_LINE} label={receiptTypeEnum['2']}
                        control={<Radio color="primary" />}
                    />
                    <FormControlLabel value={receiptTypeEnum.THREE_LINE} label={receiptTypeEnum['3']}
                        control={<Radio color="primary" />}
                    />
                </RadioGroup>
                <Typography className="text-grey">＊{t('receipt_info_tip')}</Typography>
                {receiptType === receiptTypeEnum.THREE_LINE &&
                    <Grid container style={{ marginTop: '20px' }}>
                        <Grid container>
                            <Typography>{t('receipt_info')}</Typography>
                            <Edit
                                color="primary"
                                className="pointer"
                                onClick={handleInvoiceDialog}
                                style={{ marginLeft: '10px' }}
                            />
                        </Grid>
                        <Grid container>
                            <Typography className="text-grey">{t('receipt_title')}：{receiptTitle}</Typography>
                        </Grid>
                        <Grid container>
                            <Typography className="text-grey">{t('tax_id')}：{receiptTaxId}</Typography>
                        </Grid>
                    </Grid>
                }
            </Block>

            {/* 費用統計 */}
            <Block
                title={t('fee_info')}
                contClassname="bg-white main-block"
                error={creditCardErr}
                errorMsg={t('credit_card_error_msg')}
            >
                <FormFieldGrid title={t('payment_method')}>
                    <Typography>
                        {ccLastFour ?
                            `${t('credit_card')} ···· ···· ···· ${ccLastFour}`
                            :
                            t('add_credit_card_1')
                        }
                        <Edit
                            color="primary"
                            className="pointer"
                            style={{ marginLeft: '5px' }}
                            fontSize={'small'}
                            onClick={handleCreditCardDialog}
                        />
                    </Typography>
                </FormFieldGrid>
                <FormFieldGrid title={t('inbound_item')}>
                    <Typography>
                        {orderInfo.get('totalBottle')} {t('bottle')}
                    </Typography>
                </FormFieldGrid>
                <FormFieldGrid title={'處理費用'}>
                    <Typography>
                        {formatNumber(process_fee)} {t('currency_unit')}
                        <Link
                            to="/price-detail"
                            component={RouterLink}
                            underline="none"
                            color="primary"
                            target='_blank'
                            style={{ paddingLeft: '15px' }}
                        >
                            {'處理費說明'}
                        </Link>
                    </Typography>
                </FormFieldGrid>
                <FormFieldGrid title={'儲存費用'}>
                    <Typography>
                        {formatNumber(storage_fee)} {t('currency_unit')} {'(入窖當月免費)'}
                        <Link
                            to="/price-detail"
                            component={RouterLink}
                            underline="none"
                            color="primary"
                            style={{ paddingLeft: '15px' }}
                            target='_blank'
                        >
                            {'儲存費說明'}
                        </Link>
                    </Typography>
                </FormFieldGrid>
                {/* <FormFieldGrid title={t('coupon')}>
                    <Select
                        value={selectedCoupon.get('storageCouponId') || 0}
                        variant="filled"
                        onChange={handleCouponChange}
                        autoWidth={true}
                        input={
                            <OutlinedInput
                                labelWidth={0}
                                margin="dense"
                                fullWidth
                            />
                        }
                        renderValue={(value) => (
                            <span>{selectedCoupon.get('name') || t('not_use_coupon')}</span>
                        )}
                    >
                        <MenuItem value={0}
                            style={{
                                borderBottom: '1px solid rgba(74, 79, 85, 0.1)',
                                textAlign: 'center',
                                width: '500px'
                            }}
                        >
                            {t('not_use_coupon')}
                        </MenuItem>
                        {couponlist.map((coupon, idx) => (
                            <MenuItem key={idx} value={coupon.get('storageCouponId')}>
                                <Grid container>
                                    <Grid item xs={10}>
                                        {coupon.get('name')}<br />
                                        <Typography className="text-grey">
                                            {coupon.get('description')}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={2} style={{ color: '#e74c39', fontWeight: 500 }}>
                                        {t('coupon_expiry_date')}：<br />
                                        {formatDate(coupon.get('expiredAt'))}
                                    </Grid>
                                </Grid>
                            </MenuItem>
                        ))}
                    </Select>
                </FormFieldGrid> */}
				<FormFieldGrid title={t('total')}>
                    <Typography>
                        {formatNumber(subTotal)} {t('currency_unit')}
                    </Typography>
                </FormFieldGrid>
                {/* <FormFieldGrid title={t('coupon_bonus')} className="bonus">
                    {!!selectedCoupon.size &&
                        <Typography>
                            -{formatNumber(selectedCoupon.get('couponAmount'))} {t('currency_unit')}
                        </Typography>
                    }
                </FormFieldGrid> */}
                <Grid container style={{ marginTop: '28px' }}
					style={{
                        borderTop: '2px solid rgba(74, 79, 85, 0.1)',
                        paddingTop: '20px'
                    }}
				>
                    <Grid item xs={2}>
                        <Typography className="text-grey">{t('total_fee')}</Typography>
                    </Grid>
                    <Grid item xs={10}>
                        <Typography color="primary" variant="h1">
                            {formatNumber(total)}
                            <span style={{ fontSize: '16px', color: '#4a4f55', paddingLeft: '5px' }}>
                                {t('currency_unit')}
                            </span>
                        </Typography>
                    </Grid>
                </Grid>
            </Block>
            <Button variant="contained" color="primary" fullWidth
                onClick={handleSubmit}
                disabled={total.value() <= 0}
            >
                {t('next_step_confirm')}
            </Button>
            <UpdateInvoiceDialog
                open={openInvoiceDialog}
                onClose={handleInvoiceDialog}
                onSubmit={updateInvoice}
                sourceData={{
                    receiptType,
                    receiptTitle,
                    receiptTaxId,
                }}
            />
            <AddCreditCardDialog
                open={openCreditCardDialog}
                onClose={handleCreditCardDialog}
                onSucc={udpateCreditCard}
            />
        </Fragment>
    )
}

export default createForm()(InboundDetailForm)